// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2yj8E","amount":"Amount_amount__1dpSi","tip":"Amount_tip__1gpIe","tipHeader":"Amount_tipHeader__p8r85","tipsWrap":"Amount_tipsWrap__3IvzM"};